/**
 * Replace `{key}` placeholders in a template string with values from an object,
 * mirroring the simple interpolation behaviour of react-intl / ICU MessageFormat.
 * Unmatched placeholders are left as-is.
 *
 * @note The utility isn't safe enough to be used outside of a React component.
 * Use it only in the useTranslate hook as it's the place were all of our translations
 * should go through.
 *
 * @example
 * interpolateTranslations("Hello {name}, you have {count} items", { name: "Jane", count: 3 })
 * // "Hello Jane, you have 3 items"
 */
export const interpolateTranslations = (template: string, values: Record<string, string | number>): string => {
  if (!template) {
    return ""
  }

  return template.replace(/\{(\w+)\}/g, (match, key: string) => {
    const value = values[key]
    return value !== undefined ? String(value) : match
  })
}
